import axios from 'axios'
import store from '../../store/index'
import { captureException } from '@sentry/vue'

import IsResponseNotAuthorized from '@/rules/axios/isResponseNotAuthorized'
import IsResponseServerError from '@/rules/axios/isResponseServerError'
import IsResponseError from '@/rules/axios/isResponseError'
import IsResponseRedirect from '@/rules/axios/isResponseRedirect'

function fulfilledHandler (response) {
  return response
}

function errorHandler (error) {
  // No response was received or something happened
  if (!(new IsResponseError()).isSatisfiedBy(error.response)) {
    return Promise.reject(error)
  }

  if ((new IsResponseNotAuthorized()).isSatisfiedBy(error.response)) {
    store.dispatch('goldkidProcess/component', 'error')
    return Promise.reject(error)
  }

  if ((new IsResponseRedirect()).isSatisfiedBy(error.response)) {
    window.location.href = error.response.data
    return Promise.reject(error)
  }

  captureException(error)

  if ((new IsResponseServerError()).isSatisfiedBy(error.response)) {
    store.dispatch('goldkidProcess/component', 'error')

    return Promise.reject(error)
  }

  return Promise.reject(error)
}

axios.defaults.baseURL = process.env.VUE_APP_API_ROOT
axios.defaults.withCredentials = process.env.NODE_ENV !== 'production'
axios.interceptors.response.use(fulfilledHandler, errorHandler)
